import React, { useEffect, useRef } from "react";
import axios, { API } from "@/lib/api";
import { toast } from "sonner";
import { playDing } from "@/components/pos/OnlineOrderNotifier";

// 🔔 Store-manager side: rings when the boss approved / rejected my stock adjustment (盘点).
// Polls /inventory/stocktakes/my-feed every 20s; each result is shown once and acknowledged.
const TEXTS = {
  zh: { ok: "✅ 老板已确认你的库存调整", no: "❌ 老板拒绝了你的库存调整", by: "审批人", items: "项", got: "知道了" },
  es: { ok: "✅ El dueño aprobó tu ajuste de stock", no: "❌ El dueño rechazó tu ajuste de stock", by: "Revisado por", items: "ítems", got: "Entendido" },
  en: { ok: "✅ Boss approved your stock adjustment", no: "❌ Boss rejected your stock adjustment", by: "Reviewed by", items: "items", got: "Got it" },
  pt: { ok: "✅ O dono aprovou seu ajuste de estoque", no: "❌ O dono rejeitou seu ajuste de estoque", by: "Revisado por", items: "itens", got: "Entendi" },
};
const cfg = () => TEXTS[localStorage.getItem("app_lang") || "zh"] || TEXTS.zh;

export default function StocktakeResultNotifier({ enabled = true }) {
  const shownRef = useRef(new Set());
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await axios.get(`${API}/inventory/stocktakes/my-feed`);
        if (cancelled) return;
        const t = cfg();
        for (const st of r.data?.items || []) {
          if (shownRef.current.has(st.id)) continue;
          shownRef.current.add(st.id);
          const ok = st.status === "approved";
          playDing(ok ? "crisp" : "loud");
          const ack = () => axios.post(`${API}/inventory/stocktakes/${st.id}/ack`).catch(() => {});
          (ok ? toast.success : toast.error)(ok ? t.ok : t.no, {
            description: `${t.by}: ${st.reviewed_by_name || "-"} · ${st.item_count ?? (st.items || []).length} ${t.items} · ${(st.reviewed_at || "").slice(5, 16).replace("T", " ")}`,
            duration: 60000,
            action: { label: t.got, onClick: ack },
            onAutoClose: ack, onDismiss: ack,
            id: `stocktake-result-${st.id}`,
          });
        }
      } catch { /* offline */ }
    };
    tick();
    const id = setInterval(tick, 20000);
    return () => { cancelled = true; clearInterval(id); };
  }, [enabled]);
  return null;
}
